<template>
  <el-dialog class="dialog-simple" :visible.sync="visible" title="修改计划" width="580px" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" :size="size" ref="dataForm" label-position='right' label-width="120px" v-loading="dialogLoading">
      <!-- <el-form-item prop="name" label="计划名称">
        <el-input v-model.trim="dataForm.name" placeholder="" clearable></el-input>
      </el-form-item> -->
      <el-form-item prop="startTime" label="计划开始日期">
        <el-date-picker
          :picker-options="pickerOptions"
          style="width: 100%;"
          v-model="dataForm.startTime"
          type="date"
          value-format="yyyy/MM/dd HH:mm:ss"
          placeholder="计划开始日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item prop="endTime" label="计划结束日期">
        <el-date-picker
          :picker-options="pickerOptions"
          style="width: 100%;"
          v-model="dataForm.endTime"
          type="date"
          value-format="yyyy/MM/dd HH:mm:ss"
          placeholder="计划结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item prop="describe" label="描述">
        <el-input type="textarea" :rows="2" placeholder="" v-model="dataForm.describe">
        </el-input>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" slot="footer" style="text-align: right">
      <el-button class="submit" :size="size" type="primary" @click="submitHandle()" :loading="dialogLoading">确 定</el-button>
      <el-button class="close" :size="size" @click="visible = false">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  name: 'planEdit',
  data () {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      size: 'small',
      dialogLoading: false,
      visible: false,
      dataForm: {
        name: '',
        startTime: '',
        endTime: '',
        describe: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        name: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        startTime: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        endTime: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        describe: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init (row) {
      this.visible = true
      this.dataForm = Object.assign({}, row)
    },
    submitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.dialogLoading = true
        this.$api.electricOperations.modifyElectricOperationsPlan(
          this.dataForm.id, 
          // this.dataForm.name, 
          // this.dataForm.contractId, 
          // this.dataForm.type, 
          this.dataForm.startTime,
          this.dataForm.endTime,
          this.dataForm.describe
        ).then((res) => {
          this.dialogLoading = false
          if (res.success) {
            this.$message.success('操作成功')
            this.visible = false
            this.$emit('handleQuery')
          }
        })
      })
    }, 1000, { 'leading': true, 'trailing': false }) 
  }
}
</script>

<style>

</style>